module.exports = require("osnova-cluster-launcher");


//////////////////
// WEBPACK FOOTER
// external "osnova-cluster-launcher"
// module id = 23
// module chunks = 0